import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { getShiftType, visibleShiftTypes } from './shiftTypes';

// Shows "Shift" and "Secondary Shift" as tabs, each rendering `renderContent(shiftType)`.
// The Secondary Shift tab is there only while the company allows it and the user has
// the SecondaryShiftMaster read right; with one tab left, no tab bar is drawn.
// The open tab comes from history state `shiftType`, so returning from the add/edit
// form lands on the same tab.
const ShiftTypeTabs = ({ company, getRightsForAccess, location, history, labelKey = 'label', renderContent }) => {
    const types = visibleShiftTypes(company, getRightsForAccess);
    const requested = location && location.state && location.state.shiftType;
    const initial = types.find(t => t.key === requested) || types[0];
    const [activeKey, setActiveKey] = useState(initial ? initial.key : 'primary');

    // The company settings or rights can arrive after the first render.
    useEffect(() => {
        if (types.length && !types.some(t => t.key === activeKey)) setActiveKey(initial.key);
    }, [types.map(t => t.key).join(','), activeKey]); // eslint-disable-line react-hooks/exhaustive-deps

    if (types.length === 0) {
        return <div className="text-center text-muted mt-4">You do not have access to Shift settings.</div>;
    }

    const onChange = (key) => {
        setActiveKey(key);
        // Keep the tab in history state so a reload or "back" opens it again.
        if (history && location) history.replace(location.pathname, { ...(location.state || {}), shiftType: key });
    };

    if (types.length === 1) return <React.Fragment key={types[0].key}>{renderContent(types[0])}</React.Fragment>;

    return (
        <Tabs activeKey={activeKey} onChange={onChange} style={{ padding: '0 12px' }}>
            {types.map(type => (
                <Tabs.TabPane tab={type[labelKey]} key={type.key}>
                    {/* Positioned, so a page's absolutely placed heading stays below the tab bar. */}
                    <div style={{ position: 'relative' }}>
                        {activeKey === type.key ? renderContent(getShiftType(type.key)) : null}
                    </div>
                </Tabs.TabPane>
            ))}
        </Tabs>
    );
};

export default ShiftTypeTabs;
